import { render, staticRenderFns } from "./ModalInvoice.vue?vue&type=template&id=071f1007&lang=pug&"
import script from "./ModalInvoice.vue?vue&type=script&lang=js&"
export * from "./ModalInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports